const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const uploadImageToS3 = async (file) => {
	const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
	const maxSize = 2 * 1024 * 1024

	if (!allowedTypes.includes(file.type)) {
		throw new Error('Only JPG, PNG, or WebP images are allowed.')
	}

	if (file.size > maxSize) {
		throw new Error('Image must be under 2MB.')
	}

	const params = new URLSearchParams({
		fileType: file.type,
		fileSize: file.size.toString(),
	})

	const res = await fetch(`${BASE_URL}/api/uploads/item-options-url?${params}`)
	if (!res.ok) throw new Error('Failed to get upload URL')

	const { uploadUrl, publicUrl } = await res.json()

	await fetch(uploadUrl, {
		method: 'PUT',
		headers: {
			'Content-Type': file.type,
		},
		body: file,
	})

	return publicUrl
}
